<template>
  <div class="xbsjselect">
    <div class="xbsjselect__selectdiv" @click="selectClick">
      <span class="xbsjselect__selectText">{{type[index].value}}</span>
      <svg
        style="width: 14px;position: absolute;right: 15px;top: 20px;color: #222222;transform: translateY(-50%);pointer-events: none;"
        class="Icon Icon--select-arrow"
        role="presentation"
        viewBox="0 0 19 12"
      >
        <polyline
          fill="none"
          stroke="currentColor"
          points="17 2 9.5 10 2 2"
          fill-rule="evenodd"
          stroke-width="2"
          stroke-linecap="square"
        />
      </svg>
    </div>
    <div class="xbsjselect__draw" v-show="selectshow" >
      <ul class="xbsjselect__selectOption" >
      <li v-for="(ct,i) in listdata" :key="i" @click="selectName(ct)" :style="ct == type[index].value ? 'background: #EAEBEC;':''">
        <span>{{ ct }}</span>
      </li>
    </ul>
    <div  x-arrow="" class="popper__arrow"></div>
    </div>

  </div>
</template>

<script>
export default {
  props: [
    "list",
    "type",
    "index",
    "selectattribute"
  ],
  data() {
    return {
      selectshow: false,
      currentValue:this.value
    };
  },
  computed: {
    listdata() {
      return this.list;
    }
  },
  mounted(){
    document.body.addEventListener(
      "click",
      this.debounce((e) => {
       if(!this.isParent(e.target,this.$el)){
         this.selectshow = false;
       }
      }, 100),
      false
    );
  },
  methods: {
    selectClick() {
      this.selectshow = !this.selectshow;
    },
    selectName(value) {
      this.type[this.index].value = value;
      this.selectattribute(this.type)
      this.selectshow = false;
    }
  },
};
</script>

<style scoped lang='scss'>
.xbsjselect {
  width: 100%;
  &__selectdiv {
    // display: inline-block;
    // width: 100%;
    // background: rgba(0, 0, 0, 0.4);
    // height: 28px;
    // position: relative;
    // text-align: left;
    // line-height: 28px;
    // cursor: pointer;
    // padding-left: 13px;
    // left: -2px;
    // top: 2px;
    // border-radius: 3px;
    width: 100%;
    text-align: left;
    cursor: pointer;
    height: 40px;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #DDDDDD;
    padding: 10px 36px 10px 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__selectText{
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    line-height: 20px;
    
  }
  #app &__selectOption{
    margin-top: 12px;
    width: 100%;
    background: #FFFFFF;
    border-radius: 0px 0px 4px 4px;
    position: absolute;
    z-index: 100;
    box-shadow: 0px 0px 8px 0px #DDDDDD;
    li{
      width: 100%;
      height: 40px;
      font-size: 14px;
      color: rgba(221, 221, 221, 1);
      cursor: pointer;
      padding: 10px 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      span{
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #222222;
        line-height: 20px;
        
      }
    }
    li:hover{
      background: #EAEBEC !important;
    }
  }
  &__selectOption{
    &:hover{
      li{
        background: #FFFFFF !important;
      }
    }
  }
  .popper__arrow{
    position: absolute;
    top: 49px;
    width: 12px;
    display: block;
    border-color: #00000000;
    border-style: solid;
    border-width: 4px;
    left: calc(50% - 12px);
    border-top-width: 0;
    border-bottom-color: #ffffff;
    z-index: 101;
    filter: drop-shadow(0 -1px 1px #dddddd);
  }
}

</style>